
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { RestaurantStatus } from "@/components/RestaurantStatus";
import { MenuHighlights } from "@/components/MenuHighlights";
import { MostOrdered } from "@/components/MostOrdered";
import { AboutUs } from "@/components/AboutUs";
import { Location } from "@/components/Location";
import { FAQ } from "@/components/FAQ";
import { ContactForm } from "@/components/ContactForm";
import { Footer } from "@/components/Footer";
import { WhatsAppButton } from "@/components/WhatsAppButton";

const Index = () => {
  return (
    <div className="min-h-screen bg-background text-foreground transition-colors duration-300">
      <Navbar />
      <Hero />
      <RestaurantStatus />
      <MenuHighlights />
      <MostOrdered />
      <AboutUs />
      <Location />
      <FAQ />
      <ContactForm />
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default Index;
